export default __webpack_public_path__ + "static/media/sol1.82f3dae2.png";